// extracted by mini-css-extract-plugin
export default {"btn":"buttons__btn__dQySP","btnPrimary":"buttons__btnPrimary__C_NiB","btnLink":"buttons__btnLink__eMPVm"};